import { render } from "./ServeBatch.vue?vue&type=template&id=8426e648"
import script from "./ServeBatch.vue?vue&type=script&lang=js"
export * from "./ServeBatch.vue?vue&type=script&lang=js"
script.render = render

export default script